import { createPortal } from "react-dom";
import { IoCloseSharp } from "react-icons/io5";
import { Box, Flex } from "reflexbox";
import { useColorMode } from "theme-ui";
import { Text } from "./Text";

type MoadalType = {
  backdrop?: boolean;
  onClose?: any;
  open?: boolean;
  position?: "right" | "left" | "top" | "bottom";
} & React.ComponentProps<typeof Flex>;

export function Modal({ open, backdrop, onClose, position, ...props }: MoadalType) {
  const [colorMode] = useColorMode();
  const handleClose = onClose ? onClose : () => null;

  if (!open) return null;

  if (backdrop) {
    return createPortal(
      <Flex
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
        minWidth="100vw"
        sx={{ position: "fixed", zIndex: 10000, left: 0, top: 0 }}
      >
        <Flex
          bg="primary.white_to_dark"
          p={3}
          width="80vw"
          maxWidth="750px"
          minHeight="100px"
          maxHeight="70vh"
          flexDirection="column"
          sx={{
            zIndex: 10001,
            boxShadow:
              colorMode === "dark" ? "0px 0px 31px 0px rgb(125 125 125 / 18%)" : "0px 0px 31px 0px rgba(9,9,142,0.62)",
            borderRadius: "25px",
          }}
          {...props}
        />
        <Flex
          justifyContent="center"
          alignItems="center"
          minHeight="100vh"
          minWidth="100vw"
          sx={{ position: "fixed", left: 0, top: 0 }}
          bg="rgba(0,0,0,0.8)"
          onClick={handleClose}
        />
        {onClose && (
          <>
            <Box
              sx={{
                position: "absolute",
                top: "0",
                left: "0",
                width: "100%",
                height: "100%",
              }}
              onClick={onClose}
            />
            <Box sx={{ position: "absolute", top: "10px", right: "10px" }}>
              <button onClick={onClose}>
                <Text color="white.main" style={{ cursor: "pointer" }}>
                  <IoCloseSharp fontSize="35px" />
                </Text>
              </button>
            </Box>
          </>
        )}
      </Flex>,
      document.body,
    );
  }

  return (
    <Flex
      bg="primary.white_to_dark"
      minWidth={props.width || "400px"}
      width={props.width}
      p={props.p || 3}
      sx={{
        zIndex: 9999,
        position: "absolute",
        border: "1px solid",
        borderColor: "primary.dark_to_white",
        boxShadow:
          colorMode === "dark" ? "0px 0px 31px 0px rgb(125 125 125 / 18%)" : "0px 0px 31px 0px rgba(9,9,142,0.62)",
        borderRadius: "30px",
        ...(position && { [position]: 0 }),
      }}
      {...props}
    />
  );
}

export function ModalFullScreen({ children, open, onClose, zIndex = 3000, ...props }: any) {
  if (!open) return null;
  return createPortal(
    <Flex
      bg="rgba(0,0,0,0.8)"
      alignItems="center"
      justifyContent="center"
      sx={{ position: "fixed", top: 0, bottom: 0, right: 0, left: 0, zIndex }}
      {...props}
    >
      {onClose && (
        <>
          <Box
            sx={{
              position: "absolute",
              top: "0",
              left: "0",
              width: "100%",
              height: "100%",
              zIndex: -1,
            }}
            onClick={onClose}
          />
          <Box sx={{ position: "absolute", top: "10px", right: "10px" }}>
            <button onClick={onClose}>
              <Text color="white.main" style={{ cursor: "pointer" }}>
                <IoCloseSharp fontSize="35px" />
              </Text>
            </button>
          </Box>
        </>
      )}
      {children}
    </Flex>,
    document.body,
  );
}
